import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { CompanyDetailsViewModel } from 'sections/LKSection/modules/UserModule/stores/models/CompanyDetailsViewModel'
import { useSendPassportFile } from 'sections/LKSection/modules/UserModule/utils/useSendPassportFile'
import { UploadFile } from 'components/ui/UploadFile/UploadFile'
import { Divider, Flex, FormItem, Paragraph } from 'components/uiKit'
import { ConvertedFile } from 'utils/helpers/files/fileUpload'

import { PassportPhotos } from '../../../data'
import { DocumentType, UserModuleKeys } from '../../../types'

export type PassportPhotoProps = {
  companyDetails: CompanyDetailsViewModel
  isEdit: boolean
}

export const PassportPhoto = observer(({ companyDetails, isEdit = false }: PassportPhotoProps) => {
  const trySendPassportFile = useSendPassportFile()
  const { t } = useTranslation()

  const getKey = (key: string) => `${UserModuleKeys.passportPhotoStep}.${key}`

  const isPassport = companyDetails.documentType === DocumentType.passport

  const handleFile = async (file: ConvertedFile, photoType: PassportPhotos) => {
    if (companyDetails.loading) return

    companyDetails.setLoading(true)

    const result = await trySendPassportFile(file)

    if (result) {
      switch (photoType) {
        case PassportPhotos.firtsPageWithPassportPhoto:
          companyDetails.withDocumentPhoto[0] = result.imageUrl
          companyDetails.withDocumentPhotoUI[0] = file.content
          break
        case PassportPhotos.secondPageWithPassportPhoto:
          companyDetails.withDocumentPhoto[1] = result.imageUrl
          companyDetails.withDocumentPhotoUI[1] = file.content
          break
        case PassportPhotos.firstPagePassportPhoto:
          companyDetails.documentPhoto[0] = result.imageUrl
          companyDetails.documentPhotoUI[0] = file.content
          break
        case PassportPhotos.secondPagePassportPhoto:
          companyDetails.documentPhoto[1] = result.imageUrl
          companyDetails.documentPhotoUI[1] = file.content
          break
      }
    }

    companyDetails.setLoading(false)
  }

  const handleDeleteFile = (photoType: PassportPhotos) => {
    switch (photoType) {
      case PassportPhotos.firtsPageWithPassportPhoto:
        companyDetails.withDocumentPhoto[0] = ''
        companyDetails.withDocumentPhotoUI[0] = ''
        break
      case PassportPhotos.secondPageWithPassportPhoto:
        companyDetails.withDocumentPhoto[1] = ''
        companyDetails.withDocumentPhotoUI[1] = ''
        break
      case PassportPhotos.firstPagePassportPhoto:
        companyDetails.documentPhoto[0] = ''
        companyDetails.documentPhotoUI[0] = ''
        break
      case PassportPhotos.secondPagePassportPhoto:
        companyDetails.documentPhoto[1] = ''
        companyDetails.documentPhotoUI[1] = ''
        break
    }
  }

  return (
    <Flex vertical>
      <Paragraph>
        {isPassport
          ? `${t(getKey('Сделайте фото с паспортом'))}.`
          : `${t(getKey('Сделайте 2 фото с идентификационной'))}.`}
      </Paragraph>

      <FormItem label={isPassport ? t(getKey('Фото с паспортом')) : t(getKey('Фото с идентификационной картой'))}>
        <UploadFile
          onChange={(value) => handleFile(value, PassportPhotos.firtsPageWithPassportPhoto)}
          contentUrl={companyDetails.withDocumentPhotoUI[0]}
          onDelete={() => handleDeleteFile(PassportPhotos.firtsPageWithPassportPhoto)}
          hidePreview={isEdit}
        />
      </FormItem>

      {!isPassport && (
        <FormItem label={t(getKey('Фото с идентификационной картой обратная'))}>
          <UploadFile
            onChange={(value) => handleFile(value, PassportPhotos.secondPageWithPassportPhoto)}
            contentUrl={companyDetails.withDocumentPhotoUI[1]}
            onDelete={() => handleDeleteFile(PassportPhotos.secondPageWithPassportPhoto)}
            hidePreview={isEdit}
          />
        </FormItem>
      )}

      <Divider />

      <Paragraph>
        {isPassport ? `${t(getKey('Сделайте фото паспорта'))}.` : `${t(getKey('Сделайте 2 фото идентификационной'))}.`}
      </Paragraph>

      <FormItem label={isPassport ? t(getKey('Фото паспорта')) : t(getKey('Фото идентификационной карты'))}>
        <UploadFile
          onChange={(value) => handleFile(value, PassportPhotos.firstPagePassportPhoto)}
          hidePreview={isEdit}
          contentUrl={companyDetails.documentPhotoUI[0]}
          onDelete={() => handleDeleteFile(PassportPhotos.firstPagePassportPhoto)}
        />
      </FormItem>

      <FormItem
        label={
          isPassport ? t(getKey('Фото паспорта с пропиской')) : t(getKey('Фото идентификационной карты с обратной'))
        }
      >
        <UploadFile
          onChange={(value) => handleFile(value, PassportPhotos.secondPagePassportPhoto)}
          hidePreview={isEdit}
          contentUrl={companyDetails.documentPhotoUI[1]}
          onDelete={() => handleDeleteFile(PassportPhotos.secondPagePassportPhoto)}
        />
      </FormItem>

      <Divider />
    </Flex>
  )
})
